import { FC, useState } from 'react';
import { Loader } from '@new/common/ui/Loader/Loader';
import { useStudentDashboard } from '../hooks/useStudentDashboard';
import { useGetCurrentUserQuery } from '@teachur/http-client';
import { isUserSubscribed } from '@helpers';
import { NonEnrolledStudentView } from '../components/NonEnrolledStudentView/NonEnrolledStudentView';
import { EnrolledStudentView } from '../components/EnrolledStudentView/EnrolledStudentView';
import { useVideoCallContext } from 'src/contexts/VideoCallProvider';

export const StudentDashboard: FC = () => {
  const { data: user } = useGetCurrentUserQuery();
  const { data: dashboardData, isLoading, isError } = useStudentDashboard();
  const { openVideoCall } = useVideoCallContext();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const isEnrolledAndSubscribed = !!user?.enrolledDegrees?.length && isUserSubscribed(user);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader />
      </div>
    );
  }

  if (isError || !dashboardData) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <p className="text-neutral-600 mb-4">Failed to load dashboard data</p>
          <button
            onClick={() => window.location.reload()}
            className="text-sky-600 hover:text-sky-700 font-medium"
          >
            Try again
          </button>
        </div>
      </div>
    );
  }

  const { scheduledCalls } = dashboardData;

  return (
    <div className="flex flex-col gap-8 p-6 lg:p-8">
      <div className="flex flex-col flex-1 w-full gap-4">
        {isEnrolledAndSubscribed ? (
          <EnrolledStudentView
            scheduledCalls={scheduledCalls}
            selectedDate={selectedDate}
            onDateChange={setSelectedDate}
            onJoinCall={openVideoCall}
          />
        ) : (
          <NonEnrolledStudentView />
        )}
      </div>
    </div>
  );
};
